import service from '@/utils/request';

/**
 * @Summary 获取渠道
 * @Security ApiKeyChannel
 * @accept application/json
 * @Produce application/json
 * @Success 200 {string} json "{"success":true,"data":{},"msg":"获取成功"}"
 * @Router /merchant/getChannelList [get]
 * */
export var getChannelList = function getChannelList() {
  return service({
    url: '/merchant/getChannelList',
    method: 'get'
  });
};

/**
 * @Summary 获取对应渠道中的配置项
 * @Security ApiKeyChannel
 * @accept application/json
 * @Produce application/json
 * @Success 200 {string} json "{"success":true,"data":{},"msg":"获取成功"}"
 * @Router /merchant/gteChannelItem [get]
 * */
export var gteChannelItem = function gteChannelItem(data) {
  return service({
    url: '/merchant/gteChannelItem',
    method: 'post',
    data: data
  });
};
export var getChannelIDTypeList = function getChannelIDTypeList(data) {
  return service({
    url: '/merchant/getChannelMatchId',
    method: 'post',
    data: data
  });
};
export var createChannelItem = function createChannelItem(data, interfaceStr) {
  return service({
    url: "/merchant/addPaymentsChannelPart".concat(interfaceStr),
    method: 'post',
    data: data
  });
};
export var updateChannelItem = function updateChannelItem(data, interfaceStr) {
  return service({
    url: "/merchant/editPaymentsChannelPart".concat(interfaceStr),
    method: 'post',
    data: data
  });
};
export var getChannelTypeList = function getChannelTypeList() {
  return service({
    url: '/merchant/getChannelTypeList',
    method: 'get'
  });
};